import Vuex from 'vuex'
import Vue from 'vue';
import { files } from './requireFiles';
Vue.use(Vuex);
const store = new Vuex.Store({
    modules: files
});
export default store